import gql from 'graphql-tag';

export default gql`
query {
  listRoles {
    items {
      __typename
      id
      name
    }
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Roles/AllQuery.js